<script lang="ts">
  import HeroImage from "../assets/images/hero-image.png";
  import HeroMobile from "../assets/images/hero-mobile.png";
  import HotelLandscape from "../assets/images/hilton-hotel-landscape.png";
  import Form from "../components/Form.svelte";

  export let onFormComplete = (phase: string) => {};
</script>

<svelte:head>
  <title>Home</title>
</svelte:head>

<main class="max-w-[1600px]">
  <!-- Hero Home -->
  <section class="px-3.5 md:px-7">
    <!-- image desktop -->
    <div class="md:block hidden relative z-0">
      <img src={HeroImage} alt="hero" class="h-[553px] w-full object-cover" />
      <p
        class="flex items-center gap-1.5 text-xs font-semibold text-white absolute left-3 bottom-3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="10"
          viewBox="0 0 8 10"
          fill="none"
        >
          <path
            d="M3.61111 0C1.61669 0 0 1.59875 0 3.57104C0 6.10704 3.61111 10 3.61111 10C3.61111 10 7.22222 6.10568 7.22222 3.57104C7.22222 1.59875 5.60553 0 3.61111 0ZM3.61111 5.18202C2.71142 5.18202 1.98206 4.46074 1.98206 3.57104C1.98206 2.68134 2.71142 1.96007 3.61111 1.96007C4.5108 1.96007 5.24016 2.68134 5.24016 3.57104C5.24016 4.46074 4.5108 5.18202 3.61111 5.18202Z"
            fill="white"
          />
        </svg>
        Signia by Hilton Atlanta Georgia World Congress Center
      </p>
    </div>
    <!-- image mobile -->
    <div class="md:hidden block">
      <img src={HeroMobile} alt="hero mobile" class="w-full object-cover" />
    </div>
  </section>
  <!-- END hero home -->

  <!-- Intro text -->
  <section class="px-3.5 md:px-7">
    <div class="bg-primary-off-white py-7 md:py-20 w-full">
      <div class="container-center">
        <div class="text-center">
          <h2
            class="font-hilton-serif text-4xl text-black font-normal leading-120 -tracking-0.72 mb-5"
          >
            Hilton for Business makes business stays more rewarding than ever.
          </h2>
          <p
            class="font-hilton-sans text-2xl text-black font-normal leading-8 -tracking-0.72"
          >
            To show our appreciation for all you do, Hilton for Business is
            giving away up to $50,000 to help your business grow.<br /> Enter by
            January 11.
          </p>
        </div>

        <div class="mt-10">
          <div
            class="grid grid-cols-1 md:grid-cols-3 divide-y-2 divide-x-0 md:divide-y-0 md:divide-x-2 divide-black max-w-7xl"
          >
            <!-- item -->
            <div
              class="md:px-8 first:pl-0 last:pr-0 md:py-0 py-7 text-center first:pt-0 last:pb-0"
            >
              <h4 class="font-hilton-serif text-black text-lg mb-4 text-center">
                1st Place
              </h4>
              <p class="font-bold leading-120 max-w-sm mx-auto mb-2">$50,000</p>
              <p class="leading-120 max-w-sm mx-auto">
                to invest in your business, instant Diamond status plus a
                5-night stay at Hilton
              </p>
            </div>
            <!-- item -->
            <div
              class="md:px-8 first:pl-0 last:pr-0 md:py-0 py-7 text-center first:pt-0 last:pb-0"
            >
              <h4 class="font-hilton-serif text-black text-lg mb-4 text-center">
                2nd and 3rd Place
              </h4>
              <p class="font-bold leading-120 max-w-sm mx-auto mb-2">
                $25,000 each
              </p>
              <p class="leading-120 max-w-sm mx-auto">
                to invest in your business, plus instant Diamond status
              </p>
            </div>
            <!-- item -->
            <div
              class="md:px-8 first:pl-0 last:pr-0 md:py-0 py-7 text-center first:pt-0 last:pb-0"
            >
              <h4 class="font-hilton-serif text-black text-lg mb-4 text-center">
                20 runners up
              </h4>
              <p class="leading-120 max-w-sm mx-auto">
                will receive an accelerated path to achieve Diamond status
              </p>
            </div>
          </div>
          <p class="text-xl text-center font-bold mt-8">Must be enrolled in Hilton for Business to qualify.</p>
          <div class="flex flex-col md:flex-row justify-center mb-8 md:mb-0">
            <div class="flex min-h-48 justify-center items-center text-center flex-col h-full mt-8 gap-4 grow">
              <p class="font-bold leading-120 max-w-sm mx-auto mb-2">
                Current Hilton for Business members
              </p>
              <p class="leading-120 max-w-sm grow">
                Enter using your Hilton Honors number (associated with your Hilton for Business program).
              </p>
              <a
                href="#form"
                type="button"
                class="text-lg font-bold flex items-center justify-center leading-6 text-white h-[48px] md:h-60 md:h-60 px-8 md:px-12 rounded-lg bg-primary-blue transition-all duration-300 ease-in-out hover:opacity-80"
              >
                Enter now
              </a>
            </div>
            <div class="flex min-h-48 justify-center items-center text-center flex-col h-full mt-8 gap-4 grow">
              <p class="font-bold leading-120 max-w-sm mx-auto mb-2">
                Not a Hilton for Business member?
              </p>
              <p class="leading-120 max-w-sm grow">
                Quickly and easily register your company for Hilton for Business
                then return to this page to enter.
              </p>
              <a
                href="https://www.hilton.com/en/business/login/?WT.mc_id=zCCBB0WW1MB2OLL3specialLP4H4BSweeps_Nov5HforBSweepsRegistrations6MULTIBR7EN8i145830"
                type="button"
                class="text-lg font-bold flex items-center justify-center leading-6 text-white h-[48px] md:h-60 md:h-60 px-8 md:px-12 rounded-lg bg-primary-blue transition-all duration-300 ease-in-out hover:opacity-80"
              >
                Join for free
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END intro text -->

  <!-- Half half text image -->
  <section class="px-3.5 md:px-7 py-7 md:py-20">
    <div class="container-center">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-7 items-center">
        <!-- image column -->
        <div class="relative z-0">
          <img
            src={HotelLandscape}
            alt="hilton hotel landscape"
            class="size-full object-cover"
          />
          <p
            class="flex items-center gap-1.5 text-xs font-semibold text-white absolute left-3 bottom-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="10"
              viewBox="0 0 8 10"
              fill="none"
            >
              <path
                d="M3.61111 0C1.61669 0 0 1.59875 0 3.57104C0 6.10704 3.61111 10 3.61111 10C3.61111 10 7.22222 6.10568 7.22222 3.57104C7.22222 1.59875 5.60553 0 3.61111 0ZM3.61111 5.18202C2.71142 5.18202 1.98206 4.46074 1.98206 3.57104C1.98206 2.68134 2.71142 1.96007 3.61111 1.96007C4.5108 1.96007 5.24016 2.68134 5.24016 3.57104C5.24016 4.46074 4.5108 5.18202 3.61111 5.18202Z"
                fill="white"
              ></path>
            </svg>
            Signia by Hilton Atlanta Georgia World Congress Center
          </p>
        </div>
        <!-- text column -->
        <div>
          <h2
            class="text-5xl text-black font-hilton-serif font-normal leading-120"
          >
            Make every stay count
          </h2>
          <p class="font-normal leading-120 my-7">
            Use Hilton for Business for your business travel and enjoy
            exclusive, discounted rates worldwide – with no minimum spend
            required. Plus, earn Hilton Honors Points toward future business or
            leisure trips. Business owners can register their company, invite
            employees to join the program, and start making the most of every
            stay.
          </p>
          <a
            href="https://www.hilton.com/en/business/login/?WT.mc_id=zCCBB0WW1MB2OLL3specialLP4H4BSweeps_Nov5HforBSweepsRegistrations6MULTIBR7EN8i145830"
            type="button"
            target="_blank"
            class="max-w-max text-lg font-bold flex items-center justify-center leading-6 text-white h-[48px] md:h-60 md:h-60 px-8 md:px-12 rounded-lg bg-primary-blue transition-all duration-300 ease-in-out hover:opacity-80"
          >
            Join for free
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- END half half text image -->

  <Form {onFormComplete} />
</main>

<style>
</style>
